import { render, staticRenderFns } from "./seachVue.vue?vue&type=template&id=022596e4&scoped=true&"
import script from "./seachVue.vue?vue&type=script&lang=js&"
export * from "./seachVue.vue?vue&type=script&lang=js&"
import style0 from "./seachVue.vue?vue&type=style&index=0&id=022596e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022596e4",
  null
  
)

export default component.exports